/** The query parameter key names for Fluid documents */
export var FluidQueryParams;
(function (FluidQueryParams) {
    FluidQueryParams["item"] = "item";
    FluidQueryParams["drive"] = "drive";
    FluidQueryParams["file"] = "file";
    FluidQueryParams["siteUrl"] = "siteUrl";
    FluidQueryParams["containerPath"] = "containerPath";
    /** version */
    FluidQueryParams["v"] = "v";
})(FluidQueryParams || (FluidQueryParams = {}));
//# sourceMappingURL=FluidQueryParams.js.map